import { TextField, UploadFieldProps } from '@qfa/forms';
import { isEqual } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { useFormValue } from '../hooks';
import { IconButton, InputAdornment } from '@mui/material';
import { FileUpload } from '@mui/icons-material';
import ImageUploadDialog from './ImageUploadDialog';
import { useTranslation } from 'react-i18next';

const ImageUploadField: React.FunctionComponent<UploadFieldProps> = (props) => {
  const {
    value: propValue,
    onChange,
    name,
    label,
    id,
    disabled,
    required,
    help,
    hint,
    error,
    fieldSize,
    maxWidth,
    minWidth,
    defaultValue,
    accept,
    multiple,
    moduleName,
    mode,
    sourceId,
  } = props;

  const [_value, setValue] = useFormValue<string | string[]>({
    name,
    propValue,
    onChange,
    defaultValue,
    emptyValue: multiple ? [] : '',
  });
  const { t } = useTranslation('common');
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    if (propValue && propValue.length > 0) {
      const file = propValue.length === 1 ? t('file') : t('files');
      setFileCount(`${propValue.length} ${file}`);
    }
  }, [propValue, t]);

  const [fileCount, setFileCount] = useState<string>(t('noFileChosen'));

  const singleFileName = useMemo(() => {
    return propValue?.[0]?.name || t('noFileChosen');
  }, [propValue, t]);

  //File Upload button with icon
  const FileUploadIcon = () => (
    <IconButton onClick={() => setDialogOpen(true)}>
      <FileUpload />
    </IconButton>
  );

  const renderImageUploadField = () => {
    return (
      <>
        <TextField
          name={name}
          label={label}
          id={id}
          disabled={disabled}
          required={required}
          help={help}
          hint={hint}
          error={error}
          type='text'
          value={multiple ? fileCount : singleFileName}
          onChange={() => {}}
          fieldSize={fieldSize}
          maxWidth={maxWidth}
          minWidth={minWidth}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <FileUploadIcon />
              </InputAdornment>
            ),
          }}
          inputProps={{
            accept,
            multiple,
          }}
        />
        <ImageUploadDialog
          dialogOpen={dialogOpen}
          setDialogOpen={setDialogOpen}
          moduleName={moduleName!}
          name={name}
          setFileCount={setFileCount}
          setValue={setValue}
          value={propValue as []}
          multiple={!!multiple}
          mode={mode!}
          sourceId={sourceId}
        />
      </>
    );
  };

  return renderImageUploadField();
};

export default React.memo(ImageUploadField, isEqual);
